import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AppPopupComponent } from './app-popup/app-popup.component';
import { AppsEmptyStateComponent } from './apps-empty-state/apps-empty-state.component';
import { BrowseBarItemToSuggestionTagPipe } from './browse-bar/browse-bar-item-to-suggestion-tag.pipe';
import { BrowseBarComponent } from './browse-bar/browse-bar.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { InputPopupComponent } from './input-popup/input-popup.component';
import { LinkIndicatorComponent } from './link-indicator/link-indicator.component';
import { MembersSelectorComponent } from './members-selector/members-selector.component';
import { MessagePanelComponent } from './message-panel/message-panel.component';
import { NotificationPopupComponent } from './notification-popup/notification-popup.component';
import { RestrictedMessageComponent } from './restricted-message/restricted-message.component';
import { ResultAnswerGhostComponent } from './result-answer-ghost/result-answer-ghost.component';
import { ResultGhostComponent } from './result-ghost/result-ghost.component';
import { ResultTagComponent } from './result-tag/result-tag.component';
import { SelectedItemPopupComponent } from './selected-item-popup/selected-item-popup.component';
import { ShareOptionsPermissionsComponent } from './share-options-permissions/share-options-permissions.component';
import { ShareOptionsComponent } from './share-options/share-options.component';
import { SplitButtonWrapperComponent } from './split-button-wrapper/split-button.wrapper.component';
import { TagComponent } from './suggestions-tags/suggestion-tag/suggestion-tag.component';
import { TagListComponent } from './suggestions-tags/tag-list/tag-list.component';
import { ToasterComponent } from './toaster/toaster.component';
import { ToggleWithTextComponent } from './toggle-with-text/toggle-with-text.component';
import { CustomIntervalComponent } from './verifications/custom-interval/custom-interval.component';
import { RequestHistoryItemComponent } from './verifications/requests-history-popup/request-history-item/request-history-item.component';
import { UploadFilesFailedPopupComponent } from './upload-files-failed-popup/upload-files-failed-popup.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { CardListComponent } from './card-list/card-list.component';
import { EditPopupComponent } from './edit-popup/edit-popup.component';
import { RequestsHistoryPopupComponent } from './verifications/requests-history-popup/requests-history-popup.component';
import { VerificationOptionsDetailsComponent } from './verifications/verification-options-details/verification-options-details.component';
import { MessagePopupComponent } from './message-popup/message-popup.component';

const comp = [
  TagComponent,
  BrowseBarComponent,
  BrowseBarItemToSuggestionTagPipe,
  LinkIndicatorComponent,
  AppPopupComponent,
  DropdownComponent,
  InputPopupComponent,
  MessagePanelComponent,
  NotificationPopupComponent,
  ResultGhostComponent,
  ResultAnswerGhostComponent,
  ToasterComponent,
  RestrictedMessageComponent,
  ShareOptionsComponent,
  ShareOptionsPermissionsComponent,
  ResultTagComponent,
  TagListComponent,
  SplitButtonWrapperComponent,
  SelectedItemPopupComponent,
  AppsEmptyStateComponent,
  VerificationOptionsDetailsComponent,
  MembersSelectorComponent,
  RequestsHistoryPopupComponent,
  RequestHistoryItemComponent,
  CustomIntervalComponent,
  UploadFilesFailedPopupComponent,
  EmptyStateComponent,
  ToggleWithTextComponent,
  CardListComponent,
  EditPopupComponent,
  MessagePopupComponent,
];
const modules = [SharedModule];
@NgModule({
  declarations: comp,
  imports: modules,
  exports: [...comp, ...modules],
})
export class SharedBarModule {}
